import { transition } from './transitions.js';
import type { AppAction, AppState } from './types.js';

export type AppStateListener = (state: AppState) => void;

export interface AppStore {
  getState(): AppState;
  dispatch(action: AppAction): void;
  subscribe(listener: AppStateListener): () => void;
}

export function createAppStore(initial: AppState = { kind: 'idle' }): AppStore {
  let state = initial;
  const listeners = new Set<AppStateListener>();

  return {
    getState() {
      return state;
    },
    dispatch(action) {
      const next = transition(state, action);
      if (next === state) return;
      state = next;
      for (const listener of listeners) {
        try {
          listener(state);
        } catch (err) {
          console.error('[state] listener threw:', err);
        }
      }
    },
    subscribe(listener) {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
  };
}
